module.exports = __webpack_public_path__ + "static/eric-resendiz-hero-small-825984193a2eee82b47052570e22cd48.jpg";